import { Component, ViewChild } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { AddChildContactInfoComponent } from '@se-po/shared-ui-add-child-contact-info'

const exampleHtml = `
<se-po-add-child-contact-info #childContactInfo
  [persona]="persona"
></se-po-add-child-contact-info>
<div class="form-value">
  <code>
    {{ childContactInfo.value | json }}
  </code>
</div>
`

const exampleTypescript = `
import { Component, ViewChild } from '@angular/core'
import { AddChildContactInfoComponent } from '@se-po/shared-ui-add-child-contact-info'

export class AddChildProfileDocsComponent {
  @ViewChild('childContactInfo') public childContactInfo: AddChildContactInfoComponent

  public persona = {
    first_name: 'Timmy',
    last_name: 'Smith',
    id: 1,
    gender: 'male',
    date_of_birth: '2012-01-02',
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-add-child-contact-info-example',
  template,
  styleUrls: ['../add-child-profile-docs.component.scss'],
  standalone: false,
})
export class AddChildContactInfoExampleComponent extends SeFeDocsExampleComponent {
  @ViewChild('childContactInfo') public childContactInfo: AddChildContactInfoComponent

  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public persona = {
    first_name: 'Timmy',
    last_name: 'Smith',
    id: 1,
    gender: 'male',
    date_of_birth: '2012-01-02',
  }
}
